import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent {
  breadcrumbs: Breadcrumb[] = [];

  private breadcrumbMap: Record<string, string> = {
    'dashboard': 'Dashboard',
    'master-data': 'Master Data',
    'company-industry': 'Company Industry',
    'office': 'Office',
    'client': 'Client Management',
    'employee': 'Employee Management',
    'attendance': 'Attendance',
    'leave': 'Leave Management',
    'timesheet': 'Timesheet',
    'reporting': 'Reporting'
  };

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.buildBreadcrumbs();
    });
  }

  private buildBreadcrumbs(): void {
    const path = this.router.url.split('?')[0].split('#')[0];
    const urlSegments = path.split('/').filter(s => s);
    this.breadcrumbs = urlSegments.map((segment, i) => ({
      label: this.breadcrumbMap[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
      url: '/' + urlSegments.slice(0, i + 1).join('/')
    }));
  }
}
